import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserModel } from '../models/user.model'

export interface ProfileState {
  accessToken: string | null
  refreshToken: string | null
  profile: UserModel | null
  showPhoneVerificationModal: boolean
  isAuthInitialized: boolean
}

let initialState: ProfileState = {
  accessToken: null,
  refreshToken: null,
  profile: null,
  showPhoneVerificationModal: false,
  isAuthInitialized: false,
}
export const profileReducer = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateTokens: (
      state,
      action: PayloadAction<{ accessToken: string | null; refreshToken: string | null }>,
    ) => ({
      ...state,
      accessToken: action.payload.accessToken ?? state.accessToken,
      refreshToken: action.payload.refreshToken ?? state.refreshToken,
    }),
    updateAccessToken: (state, action: PayloadAction<string | null>) => ({
      ...state,
      accessToken: action.payload,
    }),
    updateRefreshToken: (state, action: PayloadAction<string | null>) => ({
      ...state,
      refreshToken: action.payload,
    }),
    updateProfile: (state, action: PayloadAction<UserModel | null>) => ({
      ...state,
      profile: action.payload,
    }),
    showPhoneVerificationModalHandler: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showPhoneVerificationModal: action.payload,
    }),
    setAuthInitialized: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isAuthInitialized: action.payload,
    }),
  },
})

export const {
  updateTokens,
  updateAccessToken,
  updateRefreshToken,
  updateProfile,
  showPhoneVerificationModalHandler,
  setAuthInitialized,
} = profileReducer.actions
